import {EditOutlined} from '@ant-design/icons'
import {Button, Input, InputRef, Modal} from 'antd'
import React, {useRef, useState} from 'react'
import {useIntl} from 'react-intl'
import {GardenPlanVariant} from '../../entities/gardenPlanVariant'
import {instance as gardenPlanVariantsService} from '../../services/GardenPlanVariantsService'

export type GardenPlanVariantEditButtonProps = {
  gardenPlanVariant: GardenPlanVariant
  onGardenPlanVariantEdited: () => void
}

export function GardenPlanVariantEditButton({
  gardenPlanVariant,
  onGardenPlanVariantEdited,
}: GardenPlanVariantEditButtonProps) {
  const intl = useIntl()
  const [modalOpen, setModalOpen] = useState(false)
  const [name, setName] = useState(gardenPlanVariant.name)
  const [loading, setLoading] = useState(false)
  const inputRef = useRef<InputRef>(null)

  async function saveName() {
    if (loading || !name.trim()) {
      return
    }
    setLoading(true)
    try {
      const result = await gardenPlanVariantsService.editGardenPlanVariantName({
        ...gardenPlanVariant,
        name: name.trim(),
      })
      if (result.success) {
        setModalOpen(false)
        onGardenPlanVariantEdited()
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    // rendered inside a select option: the portaled modal's events still bubble to the select
    <span onClick={(e) => e.stopPropagation()}>
      <Modal
        modalRender={(modal) => (
          <div onMouseDown={(e) => e.stopPropagation()} onKeyDown={(e) => e.stopPropagation()}>
            {modal}
          </div>
        )}
        title={intl.formatMessage({id: 'editGardenPlan'})}
        open={modalOpen}
        onOk={saveName}
        onCancel={() => setModalOpen(false)}
        okButtonProps={{disabled: !name.trim(), loading}}
        destroyOnHidden
        // the select keeps focus on its own, so move it to the input explicitly
        afterOpenChange={(open) => open && inputRef.current?.focus()}
      >
        <Input
          ref={inputRef}
          value={name}
          onChange={(event) => setName(event.target.value)}
          onPressEnter={saveName}
        />
      </Modal>
      <Button
        className="edit-garden-plan-variant"
        type="link"
        size="small"
        icon={<EditOutlined />}
        onClick={() => {
          setName(gardenPlanVariant.name)
          setModalOpen(true)
        }}
      />
    </span>
  )
}
